
    <div class="dhl-wrapper-title-v2">{{configData.label}}</div>
    <div>
        <div [formGroup]="frmGroup" fxFlex>    
            <div [formArrayName]="configData.name" fxFlex class="mat-table mat-elevation-z0">
                <div *ngFor="let row of getFormTableControls(); let rowIndex = index" class="row mat-row"
                    [ngClass]="{odd: rowIndex % 2 === 2}" style="margin:0px;">            
                    <div fxFlex="calc(100%-85px)">
                        <div class="row">
                            <div *ngFor="let control of configData.controls" [formGroupName]="rowIndex" class="col mat-cell"
                                [ngClass]="getColumnsVisibility(control)" [class.hide]="control.colsHidden && (control?.UoMkey && uomData !== control?.UoMkey)">
                                <app-form-field
                                    [configData]="control" [frmGroup]="getFormTableControls()[rowIndex]"></app-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>             
        <mat-divider *ngIf="configData.contentType === 'columns' && configData.position !== 'last' " style="margin-left: 30px;" [vertical]="true"></mat-divider>   
    </div>